export default __webpack_public_path__ + "static/media/poetry.9b501b4c.png";